var _defs, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 365 122",
    style: {
      enableBackground: "new 0 0 365 122"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs21"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{fill:#005857;}\n\t.st1{fill:#2CD5C4;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.8,117.9c-3.3,0-6.6-1.3-9.1-3.8L169.8,61l51.9-53.1c2.5-2.6,5.8-3.8,9.2-3.8c7.3,0,12.7,5.9,12.7,12.7   c0,3.2-1.2,6.5-3.6,9L205.5,61l34.5,35.2c2.4,2.5,3.6,5.8,3.6,9C243.5,112,238.1,117.9,230.8,117.9",
    id: "path4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.2,117.9c-7,0-12.7-5.7-12.7-12.7V16.9c0-7,5.7-12.7,12.7-12.7c7,0,12.7,5.7,12.7,12.7v88.3   C168,112.2,162.3,117.9,155.2,117.9",
    id: "path6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.9,117.8c-32.9,0-58.2-22.2-58.2-56.8c0-31.1,21.7-56.9,58.2-56.9c10.4,0,21.5,2.7,30.4,8   c4,2.4,6.2,6.6,6.2,11c0,6.6-5.3,12.7-12.7,12.7c-2.3,0-4.5-0.6-6.6-1.8c-4.8-2.7-10.7-4.8-17.1-4.8c-20,0-32.4,13.7-32.4,31.8   c0,19.3,13.6,31.7,32.4,31.7c6.7,0,14.8-2.5,19.9-6V75.1h-8.5c-7,0-12.7-5.7-12.7-12.7c0-7,5.7-12.7,12.7-12.7h21.2   c7,0,12.7,5.7,12.7,12.7v29.3c0,3.8-1.6,7.5-4.3,10.1C345.6,112.1,330.8,117.8,314.9,117.8",
    id: "path8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,17.6c0,7.4-6,13.5-13.5,13.5c-7.4,0-13.5-6-13.5-13.5c0-7.4,6-13.5,13.5-13.5   C25.4,4.1,31.5,10.2,31.5,17.6",
    id: "path10",
    style: {
      fill: "#12504f",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.9,17.6c0,7.4-6,13.5-13.5,13.5C93,31.1,87,25,87,17.6c0-7.4,6-13.5,13.5-13.5   C107.9,4.1,113.9,10.2,113.9,17.6",
    id: "path12",
    style: {
      fill: "#12504f",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.2,117.9c-29.8,0-54-24.2-54-54v-8.6c0-7,5.7-12.7,12.7-12.7c7,0,12.7,5.7,12.7,12.7v8.9   c0,15.7,9.3,28.5,28.5,28.5c17.9,0,28.5-12.8,28.5-28.5v-8.9c0-7,5.7-12.7,12.7-12.7c7,0,12.7,5.7,12.7,12.7v8.6   C113.2,93.7,89,117.9,59.2,117.9",
    id: "path14",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkg2);
export default __webpack_public_path__ + "static/media/UKG2.5e9effcf087b428e9c971a12b21c0a7b.svg";
export { ForwardRef as ReactComponent };